import { Injectable } from '@angular/core';
import { AppFooterComponent } from './app-footer.component';
import { environment } from '@environments/environment';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class AppFooterPresenter {
  view!: AppFooterComponent;
  environmentName = environment.name.toUpperCase();
  environmentVersion = `${environment.version}`;
  currentYear = moment().format('Y');

  setView(view: AppFooterComponent): void {
    this.view = view;
  }
}
